import * as React from 'react';
import { IndexRoute, Route } from 'react-router';

import { Route as CourseraRoute } from '@coursera/react-router';

import loadOnRoute from 'bundles/common/components/loadOnRoute';
import CourseraPlusHubApp from 'bundles/coursera-plus-landing-page/CourseraPlusHubApp';
import { generateRedesignExperimentImpression } from 'bundles/coursera-plus-landing-page/utils/landingPageExperiments';
import NotFound from 'bundles/phoenix/components/NotFound';

// The redesign and control variants of the Coursera Plus landing page live
// in separate webpack chunks so users in the control arm of the A/B test do
// not download the redesign's transitive deps (PlansStack, promo-template,
// etc.). The experiment flag is evaluated per request inside the `loadOnRoute`
// factory — react-router's `match()` awaits this before SSR begins, so the
// assigned variant is fully rendered into the SSR HTML (preserves SEO and
// A/B test parity). See MONETIZE-2750.
const LandingPage = loadOnRoute(() =>
  generateRedesignExperimentImpression()
    ? import(
        /* webpackChunkName: "coursera-plus-landing-page-redesign" */
        'bundles/coursera-plus-landing-page/components/LandingPageRedesign'
      )
    : import(
        /* webpackChunkName: "coursera-plus-landing-page-control" */
        'bundles/coursera-plus-landing-page/components/LandingPage'
      )
);
const MarketingHome = loadOnRoute(() => import('bundles/coursera-plus-landing-page/components/MarketingHome'));

export default (
  <CourseraRoute
    component={CourseraPlusHubApp}
    path="/"
    handle={{
      tracking: { data: () => ({ page: { type: 'cplus_description' } }) },
    }}
  >
    {/* Coursera Lite Route */}
    <Route getComponent={MarketingHome} path="courseralite/special/:slug" />

    {/* Coursera Plus Routes */}
    <Route path="courseraplus">
      <IndexRoute getComponent={LandingPage} />
      <Route getComponent={LandingPage} path="subscribe/:id" />
      <Route getComponent={MarketingHome} path="special/:slug" />
    </Route>

    <Route component={NotFound} path="*" />
  </CourseraRoute>
);
